<template>
  <section
    id="banner"
    :class="page.acf.background_color"
  >
    <img
      v-if="page.acf.banner_image"
      :src="page.acf.banner_image.url"
      alt=""
      :style="{ objectPosition: `${page.acf.banner_image_x_pos}% ${page.acf.banner_image_y_pos}%` }"
      :class="{ 'mobile-banner': mobilebanner }"
    >

    <div
      v-if="(page.acf.banner_image && page.acf.overlay_opacity > 0)"
      :style="{ opacity: page.acf.overlay_opacity / 100 }"
      class="overlay"
    />

    <div class="content container">
      <!-- eslint-disable-next-line vuejs-accessibility/heading-has-content -->
      <h1 v-html="stripBlockTags(page.acf.banner_text)" />

      <hr v-if="page.acf.banner_sub_text">

      <div
        class="sub-text"
        v-html="stripBlockTags(page.acf.banner_sub_text)"
      />

      <div
        v-if="links"
        class="links"
      >
        <nuxt-link
          v-for="(link, i) of links"
          :key="i"
          :to="link.url"
          :class="isCurrentUrl(link.url) ? 'btn' : 'btn ghost light'"
        >
          {{ link.title }}
        </nuxt-link>
      </div>
    </div>
  </section>
</template>

<script>
import stripBlockTags from '@/utils/strip-block-tags';

export default {
  name: 'RysBanner2',

  props: {
    page: { type: Object, required: true },
    links: { type: Array, default: null },
    mobilebanner: { type: Boolean, default: false }
  },

  methods: {
    stripBlockTags,

    isCurrentUrl(href) {
      const url = new URL(href, 'https://rys.rys');

      return this.$route.path.replace(/\/$/, '') === url.pathname.replace(/\/$/, '')
        && this.$route.hash === url.hash;
    }
  }
};
</script>

<style lang="scss" scoped>
#banner {
  position: relative;
  background: $thd-black;

  &.orange {
    background: $thd-orange;
  }

  > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;

    &:not(.mobile-banner) {
      display: none;

      @media screen and (min-width: $breakpoint-lg) {
        display: block;
      }
    }
  }

  > .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000000;
    z-index: 2;
  }

  > .content {
    position: relative;
    z-index: 2;
    padding-top: 60px;
    padding-bottom: 60px;

    @media screen and (min-width: $breakpoint-lg) {
      padding-top: 140px;
      padding-bottom: 140px;
    }

    h1::v-deep {
      color: $thd-white;
      font-size: 56px;
      line-height: 56px;
      font-weight: 700;
      font-stretch: condensed;
      margin: 0;
      width: 0;
      width: 256px;

      @media screen and (min-width: $breakpoint-lg) {
        font-size: 96px;
        line-height: 88px;
        width: 512px;
      }

      strong {
        color: $thd-orange;
        font-weight: 700;
      }
    }

    hr {
      width: 100px;
      border-color: $thd-white;
      margin: 0;
      margin-top: 96px;

      @media screen and (min-width: $breakpoint-lg) {
        display: none;
      }
    }

    .sub-text {
      display: flex;
      flex-direction: column;
      gap: 24px;
      color: $thd-white;
      font-size: 18px;
      line-height: 150%;
      margin-top: 8px;

      @media screen and (min-width: $breakpoint-lg) {
        font-size: 24px;
        max-width: 50%;
      }
    }

    [href*='hah'] {
      display: flex;
      justify-content: flex-end;
    }
  }

  .links {
    margin-top: 40px;

    > * + * {
      margin-top: 16px;

      @media screen and (min-width: $breakpoint-lg) {
        margin-top: 0;
        margin-left: 32px;
      }
    }

    .btn:not(.ghost):hover {
      background: $thd-orange;
      border: 3px solid transparent;
      color: $thd-white;
    }
  }
}

.dorm-banner {
  > .content {
    display: flex !important;
    justify-content: flex-end !important;

    h1 {
      width: 135px !important;

      @media screen and (min-width: $breakpoint-md) {
        width: 256px !important;
      }

      @media screen and (min-width: $breakpoint-lg) {
        width: 512px !important;
      }
    }
  }
}
</style>
